import { Modal } from "flowbite-react";

export default function ModalDelete({ open, onClose, onConfirm, patientName, contect }) {
  return (
    <Modal show={open} onClose={onClose} size="md" popup>
      <Modal.Body>
        <div className="py-8 px-4">
          <h3 className="mb-3 text-2xl font-bold text-gray-900">
            Are you sure you want to delete <span>{patientName}</span>?
          </h3>
          <p className="text-sm text-gray-500">
            {contect}
          </p>
        </div>
        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-md bg-red-700 text-white hover:bg-red-800"
          >
            Delete
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
